import React from "react";
import { Autocomplete, TextField, Chip } from "@mui/material";

const CustomAutocomplete = (props) => {
  const {
    label,
    value,
    onChange,
    options = [],
    multiple = true,
    disabled = false,
    placeholder = "",
    isLock = false,
    isReadOnly = false,
    freeSolo = true,
    renderOptionKey = false,
    selectOne = false,
    isLabel = false,
    type = "",
    error = false,
    helperText = ""
  } = props;

  const getOptionLabel = (option) => {
    if (typeof renderOptionKey === "function") return renderOptionKey(option);
    if (typeof option === "string") return option;
    if (renderOptionKey && typeof option === "object")
      return option?.[renderOptionKey] || "";
    return option?.label || "";
  };

  const handleChange = (_, newValue, changeMethod) => {
    if (selectOne && Array.isArray(newValue)) {
      const lastItem = newValue[newValue.length - 1];
      if (options.includes(lastItem)) {
        const customValues = newValue.filter((val) => !options.includes(val));
        const finalValues = [...customValues, lastItem];
        onChange(finalValues, changeMethod);
        return;
      }
    }
    onChange(newValue, changeMethod);
  };

  return (
    <Autocomplete
      multiple={multiple}
      freeSolo={freeSolo}
      options={selectOne ? options : options}
      getOptionLabel={getOptionLabel}
      groupBy={(option) => option[type] || ""}
      value={
        multiple
          ? Array.isArray(value)
            ? value
            : []
          : value && typeof value === "object"
            ? value
            : typeof value === "string"
              ? value
              : ""
      }
      sx={{ width: "100%" }}
      onChange={handleChange}
      disabled={disabled || isLock}
      readOnly={isReadOnly}
      filterSelectedOptions
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            variant="outlined"
            label={getOptionLabel(option)}
            {...getTagProps({ index })}
            key={index}
            disabled={isLock}
          />
        ))
      }
      error={error}
      renderInput={(params) => (
        <TextField
          {...params}
          label={isLock ? "Locked" : isLabel ? label : null}
          placeholder={placeholder}
          fullWidth
          disabled={isLock}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

export default CustomAutocomplete;
